import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/App-Config';
import { ActorsService } from 'src/app/ngage-core/services/actors/actors.service';
import { UserInstanceDataService } from '../../../services/user-instance-data-service/user-instance-data.service';
import { UserInterfaceService } from '../services/user-interface/user-interface.service';

export class AuthGuard implements CanActivate, CanActivateChild {
    config = AppConfig.app;


    constructor(private uiservice: UserInterfaceService, private router: Router, private uid: UserInstanceDataService, private uis: UserInterfaceService, private actorservice: ActorsService) {

    }

    canActivate(): Promise<boolean> | Observable<boolean> | boolean {
        return this.check()
    }

    canActivateChild() {
        return this.check()
    }

    check() {
        let data = localStorage.getItem('token');
        if (!data || data == null || data == '' || data == undefined) {
            this.router.navigate(['/' + this.config.app_pathname + '/register']);
            return false;
        } else {
            data = localStorage.getItem('uuid');
            if (!data || data == null || data == '' || data == undefined) {
                // this.uid.resetUser();
                // this.uid.resetChannel();
                // this.uiservice.resetUIService();
                // localStorage.getItem('uuid');


                this.router.navigate(['/' + this.config.app_pathname + '/register']);
                return false;
            } else {
                this.uid.setUserParam('id', data);
                this.uiservice.registered=true;
                const first_name=this.uid.getUserParam('firstName');
                console.log('first_name:',first_name);
                if (first_name) {
                    return true;
                } else {
                    return this.checkUserProfileCreatePromise(data);
                }

            }
        }
    }


    checkUserProfileCreate(data): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = AppConfig.userServiceUrl + '/actors/users'
            this.actorservice.get(`${url}/${data}`).subscribe((userData: any) => {
                console.log('get User data: userData:', userData);
                if (userData.first_name) {
                    //   this.router.navigate(['/' + this.config.app_pathname + '/hometab']);
                    this.uiservice.directToHometab = true;
                    this.setUserProfileDetails(userData);
                    //   return true;
                    resolve(true);
                } else {
                    this.uiservice.directToHometab = false;
                    this.router.navigate(['/' + this.config.app_pathname + '/register/welcome']);
                    //   return false;
                    reject(false);
                }
            }, error => {
                console.log("error:get User data:", error);
                // return false;
                reject(true);
            });
        })

    }


    async checkUserProfileCreatePromise(data):Promise<boolean> {
        // return new Promise((resolve, reject) => {
        try {

            let url = AppConfig.userServiceUrl + '/actors/users'
            const userData: any = await this.actorservice.get(`${url}/${data}`).toPromise();

            console.log('get User data: userData:', userData);
            if (userData.first_name) {
                //   this.router.navigate(['/' + this.config.app_pathname + '/hometab']);
                this.uiservice.directToHometab = true;
                this.setUserProfileDetails(userData);
                return true;
            } else {
                this.uiservice.directToHometab = false;
                this.router.navigate(['/' + this.config.app_pathname + '/register/welcome']);
                return false;
                // reject(false);
            }
        }
        catch (error) {
            console.log("error:get User data:", error);
            return false;
            // reject(true);
        };
        // })

    }

    setUserProfileDetails(data) {
        this.uid.setUserParam('name', data.first_name + ' ' + data.first_name);
        this.uid.setUserParam('firstName', data.first_name);
        this.uid.setUserParam('email', data.email);
        this.uid.setUserParam('profession', data.settings.profession);
        this.uid.setUserParam('organisation_name', data.settings.organisation_name);
        this.uid.setUserParam('state', data.settings.state);
        this.uid.setUserParam('city', data.settings.city);
        this.uid.setUserParam('reference', data.settings.reference);

    }
}

